module.exports = __webpack_public_path__ + "static/media/verset_corner_lower_left.6bcb0e51.png";